/* In Social Custom Code */

/* Collapsible Collection */
function showHideCC(a, index) {
  a.forEach(b => {
    b.removeAttribute('data-collapsible-state');
  });
  a[index].setAttribute('data-collapsible-state', 'active');
}

document.addEventListener("DOMContentLoaded", function() {
  const x = document.querySelectorAll('.collapsible-collections');
  const a = document.querySelectorAll('.stl_slideshow');
  
  x.forEach(y => {
    const i = y.querySelectorAll('.collapsible-collection_content_button > a');
    const z = y.querySelectorAll('.container-wrap');
    const k = y.querySelectorAll('.collapsible-collection_content-item');
    i.forEach(j => {
      j.addEventListener('click', e => {
        //e.preventDefault();
        const index = e.target.getAttribute('data-collapsible-index') - 1;
        showHideCC(k, index);
        showHideCC(z, index);
      });
    });
  });

  a.forEach(b => {
    const i = b.querySelectorAll('.slide-content__buttons_stl');
    i.forEach(j => {
      j.addEventListener('click', e => {
        e.preventDefault();
        const index = e.target.getAttribute('data-collapsible-index') - 1;
        showHideCC(i, index);
        document.querySelector(e.target.parentElement.getAttribute('href')).querySelector('.collapsible-collection_content_button > a').click();
      });
    });
  });
});